"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPasskey = void 0;
const utils_1 = require("@aws-amplify/core/internals/utils");
const getPasskey = async () => {
    throw new utils_1.PlatformNotSupportedError();
};
exports.getPasskey = getPasskey;
